/* YSL cart — AJAX qty/remove + live totals via Section Rendering API.
   Native <form action="/cart"> still works with JS off; this enhances it.
   Event-delegated so it survives section swaps without re-binding. */
(function () {
  'use strict';

  // Copy comes from window.yslI18n (rendered by snippets/ysl-i18n-js.liquid) because a
  // .js asset cannot run Liquid's `t` filter. The literal stays as the fallback, so a
  // missing key degrades to the Vietnamese copy instead of to an empty string.
  function T(k, fallback) { var d = window.yslI18n; return (d && d[k]) || fallback; }

  /* 0₫ freebie writes (sample / gift picks) bypass Shopify's web-pixel fetch
     wrapper so they don't reach GA4/Klaviyo as add_to_cart / remove_from_cart.
     The helper lives in ysl-gwp.js — see quietFetch there. */
  function quietFetch(url, opts) {
    var g = window.YSLGwp;
    return g && g.quietFetch ? g.quietFetch(url, opts) : fetch(url, opts);
  }

  var ROOT_SEL = '[data-section-id]';
  var noteTimer = null;
  /* Bumped per mutation. Two quick clicks fire two requests, and the slower
     one can land last — its stale HTML would overwrite the newer render (and
     put back a freebie the user just unpicked). Late responses check this and
     drop out. */
  var seq = 0;
  /* Stepper-lock refcount. The `--writing` class is tied to how many qty writes
     are actually in flight, NOT to `seq`: a background refresh()/gwp render bumps
     seq, so the write's own response can hit the `my !== seq` guard and bail
     before it would clear the class — which used to strand the lock and freeze
     the +/- buttons for good. Count writes in/out instead and clear at zero. */
  var writeN = 0;
  function unlock() {
    if (writeN > 0) writeN--;
    if (writeN === 0) {
      var lr = document.querySelector('.ysl-cart' + ROOT_SEL);
      if (lr) lr.classList.remove('ysl-cart--writing');
    }
  }

  /* Hard cap on how many of one product a shopper can hold. Over it → clamp back
     and toast the hotline. UX-level only (same trade-off as the sample cap — a
     determined user can still POST more; hard enforcement needs a Shopify
     Function). Gift/freebie lines are locked separately, so this only ever hits
     normal product lines (the only ones with a stepper / editable qty). */
  var MAX_QTY = 5;
  /* The real ceiling for a line: the global 5, OR the variant's remaining stock
     when lower (Liquid writes data-max-qty = min(5, stock) for tracked+deny
     variants; a low-stock line 1–4 also gets a badge). */
  function rawCap(item) {
    var m = parseInt(item && item.getAttribute('data-max-qty'), 10);
    return isNaN(m) ? MAX_QTY : m;
  }
  /* Stepper ceiling: never below what's already in the line, so a + never
     REDUCES an over-cap qty — enforceCaps() owns pulling that back down. */
  function maxFor(item) {
    var input = item && item.querySelector('[data-qty-input]');
    var cur = input ? (parseInt(input.value, 10) || 0) : 0;
    return Math.max(rawCap(item), cur);
  }
  function qtyToast(msg) {
    var t = document.getElementById('ysl-toast');
    if (!t) { t = document.createElement('div'); t.id = 'ysl-toast'; t.className = 'ysl-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg || T('cartMaxDefault', 'Tối đa %n% sản phẩm mỗi loại — cần nhiều hơn vui lòng liên hệ hotline.').replace('%n%', MAX_QTY);
    requestAnimationFrame(function () { t.classList.add('is-visible'); });
    clearTimeout(t._t); t._t = setTimeout(function () { t.classList.remove('is-visible'); }, 3500);
  }
  /* Message when a line hits its cap: a stock-limited line names the stock, the
     plain global cap points at the hotline. */
  function capMsg(item) {
    var m = parseInt(item && item.getAttribute('data-max-qty'), 10);
    if (isNaN(m)) m = MAX_QTY;
    if (m < MAX_QTY) return T('cartMaxLow', 'Sản phẩm sắp hết hàng — đã đạt số lượng tối đa có thể mua.');
    return T('cartMaxDefault', 'Tối đa %n% sản phẩm mỗi loại — cần nhiều hơn vui lòng liên hệ hotline.').replace('%n%', m);
  }
  /* Grey the + (and the − at min) when a line sits at its bound. The + keeps
     firing clicks so a tap at the cap still shows the toast — hence a class, not
     the disabled attribute. */
  function capState(item) {
    if (!item) return;
    var input = item.querySelector('[data-qty-input]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 0;
    var max = maxFor(item);
    var inc = item.querySelector('[data-step="1"]');
    var dec = item.querySelector('[data-step="-1"]');
    if (inc) inc.classList.toggle('is-maxed', v >= max);
    if (dec) dec.classList.toggle('is-maxed', v <= 0);
  }
  function capAll(root) {
    (root || document).querySelectorAll('.ysl-cart[data-section-id] [data-cart-item]:not([data-gwp]):not([data-freebie])').forEach(capState);
    /* server HTML renders gift lines hidden by default — reveal the earned ones */
    if (window.YSLGwp && window.YSLGwp.paint) { try { window.YSLGwp.paint(); } catch (err) {} }
  }

  /* Safety net for the cap. The stepper and the PDP quantity field respect the
     limit, but /cart/add.js (PDP form, quick-add, "thường mua kèm", a raw add)
     takes ANY quantity, and the SAME variant can sit on several lines when the
     line properties differ (box-dims present on a PDP add but not a quick-add,
     an engraving, …). So the cap is per VARIANT-TOTAL, not per line: sum a
     variant's non-freebie lines and, if the sum tops rawCap, trim the excess
     from the last lines first (a duplicate line trimmed to 0 just disappears,
     merging it away). Key-addressed update.js so the trim is atomic; carries the
     drawer section too. Idempotent — once every variant sits at its cap it's a
     no-op, so the follow-up render can't loop. */
  function enforceCaps() {
    var root = document.querySelector('.ysl-cart' + ROOT_SEL);
    if (!root) return;
    var els = [].slice.call(root.querySelectorAll('[data-cart-item]'));
    function lineQty(el) {
      var inp = el.querySelector('[data-qty-input]');
      if (inp) return parseInt(inp.value, 10) || 0;
      var f = el.querySelector('.ysl-cart__qty-fixed');
      var m = f && f.textContent.match(/(\d+)/);
      return m ? parseInt(m[1], 10) : 0;
    }
    var orig = els.map(lineQty), next = orig.slice();
    /* Group by variant + its PUBLIC properties, not variant alone. Lines that
       differ only by a private `_` prop are the same item and must share one
       cap. (The prop that used to cause this, box-dims `_kich_thuoc_hop` sent by
       the PDP alone, was removed 2026-09-29 — carts from before that still hold
       such split lines until checkout, so keep this grouping.) But
       two engravings of the same shade ("Khắc tên: MOM" vs "DAD") are distinct
       gifts — capping their SUM would silently delete one. Public props render
       into the line's <dl> (private ones are filtered out), so its text is the
       right group discriminator. */
    function groupKey(el) {
      var dl = el.querySelector('.ysl-cart__props');
      return el.getAttribute('data-variant-id') + '|' + (dl ? dl.textContent.replace(/\s+/g, ' ').trim() : '');
    }
    var byVar = {};
    els.forEach(function (el, i) {
      if (el.getAttribute('data-gwp') || el.getAttribute('data-freebie')) return;
      var g = groupKey(el);
      (byVar[g] = byVar[g] || []).push(i);
    });
    var toastItem = null;
    Object.keys(byVar).forEach(function (v) {
      var idxs = byVar[v], cap = rawCap(els[idxs[0]]);
      var sum = idxs.reduce(function (s, i) { return s + next[i]; }, 0);
      var excess = sum - cap;
      for (var k = idxs.length - 1; k >= 0 && excess > 0; k--) {
        var i = idxs[k], take = Math.min(excess, next[i]);
        next[i] -= take; excess -= take; toastItem = els[idxs[0]];
      }
    });
    var updates = {};
    els.forEach(function (el, i) {
      if (next[i] === orig[i]) return;
      updates[el.getAttribute('data-key')] = next[i];
      var inp = el.querySelector('[data-qty-input]');
      if (inp) { inp.value = next[i]; capState(el); }  // reflect immediately
    });
    if (!Object.keys(updates).length) return;
    var id = root.getAttribute('data-section-id');
    var drawer = drawerSurface();
    var secList = drawer ? id + ',ysl-cart-drawer' : id;
    var my = ++seq;
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: secList, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (my !== seq) return;
        var html = state.sections && state.sections[id];
        if (html) { if (!patch(root, html)) swap(root, html); }
        var dHtml = drawer && state.sections && state.sections['ysl-cart-drawer'];
        if (dHtml) drawer.applySection(dHtml);
        updateHeader(realCount(state), state, !!dHtml);
      })
      .catch(function () {});
    if (toastItem) qtyToast(capMsg(toastItem));
  }

  /* Branded confirm before removing a line — the − at qty 1 (and a typed 0) asks
     instead of silently emptying the line. onYes runs the actual removal. */
  function confirmRemove(onYes) {
    var ov = document.getElementById('ysl-confirm');
    if (!ov) {
      ov = document.createElement('div');
      ov.id = 'ysl-confirm';
      ov.className = 'ysl-confirm';
      ov.innerHTML = '<div class="ysl-confirm__box" role="dialog" aria-modal="true" aria-labelledby="ysl-confirm-msg">'
        + '<p class="ysl-confirm__msg" id="ysl-confirm-msg">' + esc(T('cartConfirmMsg', 'Bạn có muốn xóa sản phẩm này khỏi giỏ hàng?')) + '</p>'
        + '<div class="ysl-confirm__actions">'
        + '<button type="button" class="ysl-btn ysl-btn--light ysl-confirm__btn" data-confirm-no>' + esc(T('cartConfirmKeep', 'Giữ lại')) + '</button>'
        + '<button type="button" class="ysl-btn ysl-btn--dark ysl-confirm__btn" data-confirm-yes>' + esc(T('cartConfirmYes', 'Xóa')) + '</button>'
        + '</div></div>';
      document.body.appendChild(ov);
    }
    function close() { ov.classList.remove('is-open'); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') close(); }
    /* assign (not addEventListener) so repeat opens never stack handlers */
    ov.querySelector('[data-confirm-yes]').onclick = function () { close(); try { onYes(); } catch (e) {} };
    ov.querySelector('[data-confirm-no]').onclick = close;
    ov.onclick = function (e) { if (e.target === ov) close(); };
    document.addEventListener('keydown', onKey);
    ov.classList.add('is-open');
    var no = ov.querySelector('[data-confirm-no]'); if (no) no.focus();
  }

  /* Debounce the server write on stepper taps (Vinamilk-style): the number moves
     on every tap (input.value + optimistic repaint already do that), but the
     change.js call fires ONCE ~400ms after the LAST tap, with the final quantity
     — so rapid +/- feels instant instead of fanning out N slow round trips.
     A tap on a different line flushes the pending write first. */
  var qtyTimer = null, qtyPending = null;
  function flushQty() {
    if (!qtyPending) return;
    var p = qtyPending; qtyPending = null;
    /* Resolve the CURRENT line number from the stable key at flush time: gwp
       adds gift lines on the first add, which re-renders the cart and renumbers
       every line, so the number captured at tap time may now point at a
       different item (the bug where a qty bumped to 5 snapped back). Key gone =
       line removed → nothing to write. */
    var el = p.key && p.root.querySelector('[data-cart-item][data-key="' + p.key + '"]');
    if (!el) return;
    var line = parseInt(el.getAttribute('data-line'), 10);
    /* soft: the stepper already repainted optimistically, so don't page-lock
       clicks while this write reconciles — the buttons must stay live. */
    changeLine(p.root, line, p.qty, true);
  }
  function scheduleChange(root, key, qty) {
    if (qtyPending && qtyPending.key !== key) flushQty();
    qtyPending = { root: root, key: key, qty: qty };
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(flushQty, 400);
  }

  function rootFor(el) {
    var section = el.closest('.ysl-cart');
    return section && section.matches(ROOT_SEL) ? section : document.querySelector('.ysl-cart' + ROOT_SEL);
  }

  function setLoading(root, on) {
    if (root) root.classList.toggle('ysl-cart--loading', !!on);
  }

  /* Swap the section HTML returned by the Section Rendering API. */
  function swap(root, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('.ysl-cart' + ROOT_SEL) || doc.querySelector('.ysl-cart');
    if (next && root) root.replaceWith(next);
    return next;
  }

  /* Identity of the cart's structure. Same shape → the response differs only in
     numbers and can be written into the DOM already on screen; anything else
     (a line gone, a freebie picked) still needs the full swap. */
  function shape(scope) {
    var keys = [];
    scope.querySelectorAll('[data-cart-item]').forEach(function (i) { keys.push(i.getAttribute('data-key')); });
    return (scope.querySelector('.ysl-cart__empty') ? 'E:' : '') + keys.join('|');
  }

  /* Patch the numbers in place instead of replacing the whole section. The cart
     section is heavy — swapping it re-decodes every product image, collapses
     the <details> panels (pickers, coupons) and throws away scroll and focus.
     For a quantity change none of that has moved; only prices did.
     Returns false when the structure changed, so the caller falls back to swap. */
  function patch(root, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('.ysl-cart' + ROOT_SEL) || doc.querySelector('.ysl-cart');
    if (!next || !root) return false;
    if (shape(next) !== shape(root)) return false;

    var nItems = next.querySelectorAll('[data-cart-item]');
    var cItems = root.querySelectorAll('[data-cart-item]');
    for (var i = 0; i < cItems.length; i++) {
      var nTotal = nItems[i].querySelector('[data-line-total]');
      var cTotal = cItems[i].querySelector('[data-line-total]');
      if (nTotal && cTotal) cTotal.innerHTML = nTotal.innerHTML;

      var nFixed = nItems[i].querySelector('.ysl-cart__qty-fixed');
      var cFixed = cItems[i].querySelector('.ysl-cart__qty-fixed');
      if (nFixed && cFixed) cFixed.textContent = nFixed.textContent;

      /* server truth: a qty can come back clamped by stock */
      var nQty = nItems[i].querySelector('[data-qty-input]');
      var cQty = cItems[i].querySelector('[data-qty-input]');
      if (nQty && cQty && cQty.value !== nQty.value) cQty.value = nQty.value;
      /* carry the per-line stock cap (stock can move between renders) */
      var nMax = nItems[i].getAttribute('data-max-qty');
      if (nMax !== null) cItems[i].setAttribute('data-max-qty', nMax);

      /* per-line discount list (BXGY / % code) — a % code's amount moves with
         every qty edit, so sync it alongside the price */
      var nLd = nItems[i].querySelector('[data-line-discounts]');
      var cLd = cItems[i].querySelector('[data-line-discounts]');
      if (nLd && cLd) cLd.innerHTML = nLd.innerHTML;
    }

    var nBar = next.querySelector('[data-ship-bar]');
    var cBar = root.querySelector('[data-ship-bar]');
    if (nBar && cBar) {
      /* the tier list is a <details> the shopper can collapse — keep their state */
      var open = cBar.querySelector('details');
      var wasOpen = open ? open.open : null;
      cBar.innerHTML = nBar.innerHTML;
      var again = wasOpen === null ? null : cBar.querySelector('details');
      if (again) again.open = wasOpen;
    }

    /* discount rows are a container of several <div>s, not a single text node —
       sync the block wholesale or a % code keeps its stale amount while the
       totals around it move */
    var nDisc = next.querySelector('[data-cart-discounts]');
    var cDisc = root.querySelector('[data-cart-discounts]');
    if (nDisc && cDisc) cDisc.innerHTML = nDisc.innerHTML;

    ['[data-cart-subtotal]', '[data-cart-total]', '[data-cart-count-label]'].forEach(function (sel) {
      var n = next.querySelector(sel);
      var c = root.querySelector(sel);
      if (n && c) c.textContent = n.textContent;
    });

    ['data-cart-count', 'data-subtotal'].forEach(function (attr) {
      var v = next.getAttribute(attr);
      if (v !== null) root.setAttribute(attr, v);
    });

    clearBusy(root);
    root.classList.remove('ysl-cart--loading', 'ysl-cart--syncing');
    capAll(root);
    enforceCaps();
    return true;
  }

  function clearBusy(root) {
    if (!root) return;
    root.querySelectorAll('[data-line-total].is-busy').forEach(function (el) { el.classList.remove('is-busy'); });
  }

  /* Header badge = purchased units only, the same filter as ysl_real_count in
     sections/ysl-header.liquid. cart.item_count also counts the gifts that sit in
     the cart dormant and hidden, so the badge jumped after every edit until the
     next page load. */
  function realCount(cart) {
    if (!cart || !cart.items) return cart ? cart.item_count : 0;
    return cart.items.reduce(function (n, i) {
      var p = i.properties || {};
      return (p._gwp == null && p._giftwrap == null && p._sample == null && p._gift == null && p._tier_gift == null) ? n + i.quantity : n;
    }, 0);
  }

  /* Mirror cart count into the YSL header (label + badge). */
  function mirrorHeader(count) {
    document.querySelectorAll('.ysl-head__cart-count').forEach(function (el) {
      el.textContent = count;
    });
    var label = document.querySelector('.ysl-head__cart .ysl-head__acct-label');
    if (label) label.textContent = label.textContent.replace(/\(\d+\)/, '(' + count + ')');
  }

  /* Mirror + announce. cart:updated is what ysl-gwp.js listens to, so ONLY the
     user-initiated mutations fire it. The gwp-triggered refresh() mirrors the
     header silently — re-announcing there just makes gwp re-run every render.
     The post-mutation cart rides along in the event so gwp can plan WITHOUT its
     own cart.js read. */
  function updateHeader(count, cart, rendered) {
    mirrorHeader(count);
    /* rendered = this mutation already handed the OTHER surface its HTML, so it
       must not go fetch a render of its own. */
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { count: count, cart: cart, source: 'cart', rendered: !!rendered } }));
  }

  /* The drawer, when it's on screen and not mid-edit. Its section rides along in
     this page's own mutation (`sections` takes a comma-separated list), so it
     never has to fetch a second render of the same cart. Mid-edit it is left
     alone — the debounced refresh path has its own qtyPending guard. */
  function drawerSurface() {
    if (!document.querySelector('[data-cart-drawer]')) return null;
    var d = window.YSLCartDrawer;
    if (!d || !d.applySection) return null;
    if (d.isBusy && d.isBusy()) return null;
    return d;
  }

  /* Swap in section HTML gwp already fetched (its mutation carried `sections`),
     so a gwp scale doesn't need a second render round trip. */
  function applySection(html) {
    var root = document.querySelector('.ysl-cart' + ROOT_SEL);
    if (!root || !html) return;
    var next = patch(root, html) ? root : swap(root, html);
    capAll();
    enforceCaps();
    var count = next && parseInt(next.getAttribute('data-cart-count'), 10);
    if (count || count === 0) mirrorHeader(count);
  }

  /* ---------- Optimistic UI ----------
     The server round trips take ~2-3s on the heavy cart section, so a stepper
     click repaints the affected bits IMMEDIATELY from data hooks — the changed
     line total, the GWP samples it scales, the summary totals and the whole tier
     bar — then the authoritative server render lands and overwrites everything
     (so any drift self-heals). Strictly DOM-only: no fetch, no event dispatch,
     so it can never feed the mutation flow. Wrapped in try/catch by the caller. */
  function esc(s) { return String(s).replace(/[&<>]/g, function (c) { return c === '&' ? '&amp;' : c === '<' ? '&lt;' : '&gt;'; }); }

  function formatMoney(cents, format) {
    format = format || '{{amount}}';
    function withDelims(num, precision, thousands, decimal) {
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(num) || num == null) return '0';
      num = (num / 100).toFixed(precision);
      var parts = num.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return whole + (parts[1] ? decimal + parts[1] : '');
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case 'amount': return withDelims(cents, 2);
        case 'amount_no_decimals': return withDelims(cents, 0);
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        case 'amount_with_space_separator': return withDelims(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator': return withDelims(cents, 0, ' ', '');
        case 'amount_with_period_and_space_separator': return withDelims(cents, 2, ' ', '.');
        default: return withDelims(cents, 2);
      }
    });
  }
  function moneyOf(root, cents) {
    return formatMoney(cents, (root && root.getAttribute('data-money-format')) || '{{amount}}');
  }

  var TIER_CHECK = '<svg viewBox="0 0 16 16" width="11" height="11" fill="none"><path d="M3.5 8.5l3 3L13 5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var TIER_CROSS = '<svg viewBox="0 0 16 16" width="11" height="11" fill="none"><path d="M4.5 4.5l7 7M11.5 4.5l-7 7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function scaleSamples(root, productId, parentQty) {
    var rules = window.YSL_GWP_RULES || [];
    rules.forEach(function (rule) {
      if ((rule.buy_products || []).map(String).indexOf(String(productId)) === -1) return;
      var per = parseInt(rule.gift_qty, 10) || 1;
      var buyQ = parseInt(rule.buy_qty, 10) || 1;
      var max = parseInt(rule.max_gifts, 10) || 0;
      var want = Math.floor(parentQty / buyQ) * per;
      if (max > 0) want = Math.min(want, max);
      var gv = String(rule.gift_variant);
      var li = null;
      root.querySelectorAll('[data-cart-item][data-gwp]').forEach(function (el) {
        if (el.getAttribute('data-variant-id') === gv) li = el;
      });
      if (!li) return;
      var qf = li.querySelector('.ysl-cart__qty-fixed');
      /* Only stamp a real earned count; never "Số lượng: 0" (the line stays in the
         cart dormant, hidden by paint()'s .is-gwp-off — visibility is paint's job,
         not an inline display here, which would only fight it). */
      if (qf && want > 0) qf.textContent = T('cartQtyFixed', 'Số lượng: %n%').replace('%n%', want);
      li.style.opacity = '';
    });
  }

  function updateProgress(root, totalCents) {
    var tier = root.querySelector('.ysl-tier');
    if (!tier) return;
    var max = parseInt(tier.getAttribute('data-max'), 10) || 0;
    tier.setAttribute('data-total', totalCents);
    var fill = tier.querySelector('[data-ship-fill]');
    if (fill && max > 0) fill.style.width = Math.min(100, Math.round(totalCents * 100 / max)) + '%';
    tier.querySelectorAll('.ysl-tier-pt').forEach(function (pt) {
      var th = parseInt(pt.getAttribute('data-th'), 10) || 0;
      var pip = pt.querySelector('.ysl-tier-pip');
      if (!pip) return;
      var ok = totalCents >= th;
      pip.classList.toggle('is-reached', ok);
      pip.innerHTML = ok ? TIER_CHECK : TIER_CROSS;
    });
    /* data-label / data-reward hold ready HTML (the snippet escapes plain text and
       renders rich text with its links), so they go in unescaped. */
    var nextTh = 0, nextLabel = '';
    tier.querySelectorAll('.ysl-tier__row').forEach(function (row) {
      var th = parseInt(row.getAttribute('data-th'), 10) || 0;
      var label = row.getAttribute('data-label') || '';
      var reward = row.getAttribute('data-reward') || label;
      var idx = row.getAttribute('data-idx') || '';
      var ok = totalCents >= th;
      row.classList.toggle('is-reached', ok);
      var ico = row.querySelector('.ysl-tier__row-ico');
      if (ico) ico.innerHTML = ok ? TIER_CHECK : TIER_CROSS;
      var txt = row.querySelector('.ysl-tier__row-text');
      /* th <= 100 cents = an "any order" tier (min 1₫): never a spend target and
         never "Còn 1₫ để được …" — same rules as snippets/ysl-promo-tiers.liquid,
         which renders the drawer copy of this bar server-side. */
      var anyOrder = th <= 100;
      if (txt) txt.innerHTML = '<sup>(' + esc(idx) + ')</sup>' + ((ok || anyOrder) ? reward
        : T('tierRemaining', 'Còn %amount% để được %reward%')
            .replace('%amount%', moneyOf(root, th - totalCents)).replace('%reward%', function () { return label; }));
      if (!ok && !anyOrder && (nextTh === 0 || th < nextTh)) { nextTh = th; nextLabel = label; }
    });
    var head = tier.querySelector('.ysl-tier__head');
    if (head) head.innerHTML = nextTh === 0
      ? T('tierAllMet', 'Chúc mừng! Bạn đã đủ điều kiện nhận toàn bộ quà tặng!')
      : T('tierSpendMore', 'Mua thêm %amount% để được %reward%')
          .replace('%amount%', '<strong>' + moneyOf(root, nextTh - totalCents) + '</strong>')
          .replace('%reward%', function () { return nextLabel; });
  }

  /* After the intermediate change.js render (which shows the samples at their
     PRE-scale quantity for the ~1.5s until gwp catches up), re-project every GWP
     sample line off the parent quantities now in the DOM — so the sample count
     never visibly flickers back before gwp's authoritative render lands on the
     same value. DOM-only. */
  function projectSamples(root) {
    if (!root) return;
    var rules = window.YSL_GWP_RULES || [];
    /* order-value total (excl. gifts) for min_subtotal rules */
    var total = 0;
    root.querySelectorAll('[data-cart-item]').forEach(function (el) {
      if (el.getAttribute('data-gwp')) return;
      var unit = parseInt(el.getAttribute('data-unit'), 10) || 0;
      var inp = el.querySelector('[data-qty-input]');
      total += unit * (inp ? (parseInt(inp.value, 10) || 0) : 1);
    });
    /* data-unit nets line-level discounts only; subtract the order (cart-level)
       discount so a min_subtotal gift matches cart.total_price (see ysl-gwp.js). */
    total -= parseInt(root.getAttribute('data-gwp-discount'), 10) || 0;
    if (total < 0) total = 0;
    rules.forEach(function (rule) {
      var per = parseInt(rule.gift_qty, 10) || 1;
      var max = parseInt(rule.max_gifts, 10) || 0;
      var want;
      if (rule.min_subtotal) {
        /* MUST use the same order-value math as gwp.wanted — the old buyQty path
           gave 0 for a min_subtotal gift (no buy_products), stamping "Số lượng: 0"
           and hiding a gift the shopper had actually earned. */
        var min = (parseInt(rule.min_subtotal, 10) || 0) * 100;
        want = min > 0 ? Math.floor(total / min) * per : 0;
      } else {
        var buyP = (rule.buy_products || []).map(String);
        var buyV = (rule.buy_variants || []).map(String);
        var buyQty = 0;
        root.querySelectorAll('[data-cart-item]').forEach(function (el) {
          if (el.getAttribute('data-gwp')) return;
          var pid = el.getAttribute('data-product-id'), vid = el.getAttribute('data-variant-id');
          if (buyP.indexOf(String(pid)) === -1 && buyV.indexOf(String(vid)) === -1) return;
          var inp = el.querySelector('[data-qty-input]');
          buyQty += inp ? (parseInt(inp.value, 10) || 0) : 1;
        });
        var need = parseInt(rule.buy_qty, 10) || 1;
        want = Math.floor(buyQty / need) * per;
      }
      if (max > 0) want = Math.min(want, max);
      var gv = String(rule.gift_variant), li = null;
      root.querySelectorAll('[data-cart-item][data-gwp]').forEach(function (el) {
        if (el.getAttribute('data-variant-id') === gv) li = el;
      });
      if (!li) return;
      var qf = li.querySelector('.ysl-cart__qty-fixed');
      /* only a real earned count — never "Số lượng: 0"; the dormant line stays
         put and paint() (the .is-gwp-off class) owns show/hide, not inline display. */
      if (qf && want > 0) qf.textContent = T('cartQtyFixed', 'Số lượng: %n%').replace('%n%', want);
    });
  }

  function optimistic(root, li, oldQty, newQty) {
    if (!root || !li) return;
    var unit = parseInt(li.getAttribute('data-unit'), 10) || 0;
    var now = li.querySelector('.ysl-cart__line-now') || li.querySelector('[data-line-total]');
    if (unit > 0 && now) now.textContent = moneyOf(root, unit * newQty);

    var sub = (parseInt(root.getAttribute('data-subtotal'), 10) || 0) + unit * (newQty - oldQty);
    if (sub < 0) sub = 0;
    root.setAttribute('data-subtotal', sub);
    var subEl = root.querySelector('[data-cart-subtotal]');
    var totEl = root.querySelector('[data-cart-total]');
    if (subEl) subEl.textContent = moneyOf(root, sub);
    if (totEl) totEl.textContent = moneyOf(root, sub);

    scaleSamples(root, li.getAttribute('data-product-id'), newQty);
    updateProgress(root, sub);
    /* reveal/hide the gift line on THIS tap, before the server render — the line
       is already in the cart, so qualifying is a pure CSS toggle. */
    if (window.YSLGwp && window.YSLGwp.paint) { try { window.YSLGwp.paint(); } catch (err) {} }
  }

  /* The cart as it will be AFTER this change, read off the DOM — which the last
     authoritative response rendered. gwp plans off this instead of spending a
     cart.js read of its own, which is what lets the gift adjustment ride along
     in the same request. Shaped like /cart.js so plan() needs no special case. */
  function predictCart(root, changedKey, newQty) {
    var items = [];
    var total = 0;
    root.querySelectorAll('[data-cart-item]').forEach(function (li) {
      var key = li.getAttribute('data-key');
      var unit = parseInt(li.getAttribute('data-unit'), 10) || 0;
      var qty;
      if (key === changedKey) {
        qty = newQty;
      } else {
        var inp = li.querySelector('[data-qty-input]');
        if (inp) {
          qty = parseInt(inp.value, 10) || 0;
        } else {
          /* gift / freebie lines print "Số lượng: N" instead of a stepper */
          var fixed = li.querySelector('.ysl-cart__qty-fixed');
          var m = fixed && fixed.textContent.match(/\d+/);
          qty = m ? parseInt(m[0], 10) : 1;
        }
      }
      var gwp = li.getAttribute('data-gwp');
      items.push({
        key: key,
        variant_id: li.getAttribute('data-variant-id'),
        product_id: li.getAttribute('data-product-id'),
        quantity: qty,
        properties: gwp ? { _gwp: gwp } : {}
      });
      total += unit * qty;
    });
    /* net of the order (cart-level) discount, so a folded min_subtotal gift
       matches cart.total_price the server plans on (see ysl-gwp.js domCart). */
    total -= parseInt(root.getAttribute('data-gwp-discount'), 10) || 0;
    if (total < 0) total = 0;
    return { total_price: total, items: items };
  }

  function changeLine(root, line, quantity, soft, quiet) {
    var id = root.getAttribute('data-section-id');
    var my = ++seq;
    /* Only the price of the edited line shows it is waiting on the server —
       the rest of the page must not move. */
    var busy = root.querySelector('[data-cart-item][data-line="' + line + '"] [data-line-total]');
    if (busy) busy.classList.add('is-busy');
    /* --syncing locks input against a racing second click WITHOUT dimming the
       page; --loading (which does dim) stays for the mutations that really do
       rebuild the section, like picking a freebie. A SOFT change (the debounced
       stepper) skips the lock: the number is already repainted optimistically
       and the seq guard handles stale responses, so blocking clicks here just
       deadens the +/- buttons for the length of the round trip. */
    if (!soft) root.classList.add('ysl-cart--syncing');
    /* Lock the +/- steppers for the length of the round trip: a click that lands
       mid-fetch would race the re-render and make the number flicker. The 400ms
       debounce window BEFORE this point stays live, so rapid tapping still works —
       only the actual server write disables the buttons. */
    writeN++; if (root) root.classList.add('ysl-cart--writing');

    /* Ask gwp whether this change also moves a gift line. If it does — and the
       gift already exists, so no add.js is needed — both go out as ONE
       key-addressed update.js. That drops the old three-request chain (change.js
       → gwp's cart.js → gwp's update.js) to one. gwp's listener still runs
       afterwards and verifies against the real cart, so a mispredicted fold
       self-heals; it just no longer sits in front of the shopper. */
    var el = root.querySelector('[data-cart-item][data-line="' + line + '"]');
    var key = el && el.getAttribute('data-key');
    var updates = null;
    if (key && window.YSLGwp && window.YSLGwp.fold) {
      try {
        var gift = window.YSLGwp.fold(predictCart(root, key, quantity));
        if (gift) { updates = gift; updates[key] = quantity; }
      } catch (err) { updates = null; }
    }

    var drawer = drawerSurface();
    var secList = drawer ? id + ',ysl-cart-drawer' : id;
    var body = updates
      ? { updates: updates, sections: secList, sections_url: window.location.pathname }
      : { line: line, quantity: quantity, sections: secList, sections_url: window.location.pathname };

    (quiet ? quietFetch : fetch)(window.Shopify.routes.root + (updates ? 'cart/update.js' : 'cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (my !== seq) return;
        var html = state.sections && state.sections[id];
        if (html) {
          var nr = patch(root, html) ? root : swap(root, html);
          /* this render still shows samples at their pre-scale qty; project them
             to the target now so they don't flicker before gwp's render lands. */
          try { projectSamples(nr); } catch (err) { /* cosmetic only */ }
        } else {
          window.location.reload();
        }
        var dHtml = drawer && state.sections && state.sections['ysl-cart-drawer'];
        if (dHtml) drawer.applySection(dHtml);
        /* announce AFTER the swap, with the post-change cart, so gwp plans off
           it (no cart.js read) and re-renders once via its own mutation. */
        updateHeader(realCount(state), state, !!dHtml);
      })
      .catch(function () { window.location.reload(); })
      /* Always release the stepper lock when THIS write settles, even when the
         `my !== seq` guard bailed out above — otherwise the buttons stay dead. */
      .finally(unlock);
  }

  /* Freebies (gift / sample): add with a private property so the cart can
     render them locked at qty 1, or remove the matching line when unpicking.
     The max-N cap is enforced here + in Liquid (UX only — a determined user can
     still bypass it; hard enforcement would need a Shopify Function). */
  /* Surface an add failure (out of stock, etc.) next to the button instead of
     reloading the page, which would hide the reason. */
  function pickError(btn, msg) {
    var root = rootFor(btn);
    setLoading(root, false);
    var card = btn.closest('.ysl-cart__pick-card') || btn.parentNode;
    var el = card.querySelector('.ysl-cart__pick-err');
    if (!el) {
      el = document.createElement('p');
      el.className = 'ysl-cart__pick-err';
      card.appendChild(el);
    }
    el.textContent = msg || T('cartErrAdd', 'Không thêm được sản phẩm này.');
  }

  function pickFreebie(root, btn) {
    var kind = btn.getAttribute('data-kind');
    var variantId = btn.getAttribute('data-variant');
    var picked = btn.getAttribute('data-picked') === 'true';
    var id = root.getAttribute('data-section-id');

    if (picked) {
      var line = null;
      root.querySelectorAll('[data-cart-item]').forEach(function (li) {
        /* a picker's own line — never a loyalty tier gift of the same variant */
        var kind = li.getAttribute('data-freebie');
        if (kind && kind !== 'tier' && li.querySelector('[data-remove]')) {
          if (li.getAttribute('data-variant-id') === variantId) line = li.getAttribute('data-line');
        }
      });
      if (line) { changeLine(root, parseInt(line, 10), 0, false, true); return; }
      // fall back to a cart lookup when the line isn't tagged in the DOM
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          for (var i = 0; i < cart.items.length; i++) {
            if (String(cart.items[i].variant_id) === String(variantId)) { changeLine(root, i + 1, 0, false, true); return; }
          }
        });
      return;
    }

    var section = btn.closest('[data-pick]');
    var max = parseInt(section.getAttribute('data-max'), 10) || 0;
    var count = parseInt(section.getAttribute('data-count'), 10) || 0;
    if (max && count >= max) return;

    var props = {};
    props[kind === 'sample' ? '_sample' : '_gift'] = 'true';
    var my = ++seq;
    setLoading(root, true);
    quietFetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }], sections: id, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (my !== seq) return;
        if (!res.ok) { pickError(btn, res.body && (res.body.description || res.body.message)); return; }
        var html = res.body.sections && res.body.sections[id];
        var next = html ? swap(root, html) : null;
        /* count off the re-rendered section root — saves a separate cart.js */
        var count = next && parseInt(next.getAttribute('data-cart-count'), 10);
        if (count || count === 0) updateHeader(count);
      })
      .catch(function () { pickError(btn, null); });
  }

  /* --- Gift options (hộp quà / phụ kiện / thiệp) ---
     Everything is a real product line carrying the private property _giftwrap
     (box|acc|card); the gift message lives in cart attributes. Enforcement is
     UX-only, same trade-off as the freebie pickers above.
     See docs/wiki/gift-wrapping-build.md. */

  /* removes = array of variant ids to drop, add = {id, properties} or null.
     Runs sequentially so the final render already reflects both steps. */
  function wrapUpdate(root, removes, add) {
    var id = root.getAttribute('data-section-id');
    var my = ++seq;
    setLoading(root, true);

    /* Same door as changeLine: both requests carry BOTH sections, so neither
       surface ever fetches a render of the same cart again, and the count comes
       off the response instead of a trailing /cart.js (was 3-4 round trips). */
    var drawer = drawerSurface();
    var secList = drawer ? id + ',ysl-cart-drawer' : id;

    var step = Promise.resolve(null);
    if (removes && removes.length) {
      var updates = {};
      removes.forEach(function (v) { updates[v] = 0; });
      step = fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates, sections: secList, sections_url: window.location.pathname })
      }).then(function (r) { return r.json(); });
    }

    step
      .then(function (state) {
        if (my !== seq) return null;
        if (!add) return state;
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: add.id, quantity: 1, properties: add.properties }],
            sections: secList,
            sections_url: window.location.pathname
          })
        }).then(function (r) { return r.json(); });
      })
      .then(function (state) {
        if (my !== seq || !state) return;
        var html = state.sections && state.sections[id];
        if (!html) { window.location.reload(); return; }
        /* count off the re-rendered section root (data-cart-count) — an add.js
           response isn't guaranteed to carry item_count */
        var count = parseInt(swap(root, html).getAttribute('data-cart-count'), 10);
        if (isNaN(count)) count = state.item_count || 0;
        var dHtml = drawer && state.sections && state.sections['ysl-cart-drawer'];
        if (dHtml) drawer.applySection(dHtml);
        updateHeader(count, null, !!dHtml);
      })
      .catch(function () { window.location.reload(); });
  }

  function wrapLines(block) {
    return (block.getAttribute('data-wrap-lines') || '')
      .split(',')
      .filter(function (v) { return v; });
  }

  function pickBox(root, input) {
    var block = input.closest('[data-wrap]');
    var current = block.getAttribute('data-box-current');
    if (input.value === 'none') {
      /* "Không gói quà" clears the box AND its accessories (staging behaviour) */
      wrapUpdate(root, wrapLines(block), null);
      return;
    }
    var removes = current && current !== '0' ? [current] : [];
    wrapUpdate(root, removes, { id: input.value, properties: { _giftwrap: 'box' } });
  }

  function pickAcc(root, input) {
    if (input.checked) wrapUpdate(root, [], { id: input.value, properties: { _giftwrap: 'acc' } });
    else wrapUpdate(root, [input.value], null);
  }

  /* The card product is one variant; "with message" vs "blank" differ only by a
     public property, so switching means removing the old line first. */
  function pickCard(root, input) {
    var variant = input.getAttribute('data-variant');
    if (input.value === 'none') { wrapUpdate(root, [variant], null); return; }
    var kind = input.value === 'blank' ? 'Thiệp trắng' : 'Có lời nhắn';
    wrapUpdate(root, [variant], { id: variant, properties: { _giftwrap: 'card', 'Loại thiệp': kind } });
  }

  /* Gift message → cart attributes. No section re-render: the inputs are live
     and swapping the HTML mid-typing would steal focus. */
  var msgTimer = null;
  function saveMessage(block) {
    var attrs = {};
    block.querySelectorAll('[data-wrap-msg]').forEach(function (el) {
      attrs[el.getAttribute('data-wrap-msg')] = el.value;
    });
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  /* Change a line's variant (shade/size) in place. The Ajax cart has no
     "swap variant" call — /cart/add.js prepends the new line and reissues line
     keys, so an index/key-based remove targets the wrong row. /cart/update.js
     keyed by variant id is atomic: set the old variant to 0 and the new one to
     the same quantity in one request. */
  function changeVariant(root, oldId, newId, qty) {
    if (String(oldId) === String(newId)) return;
    var id = root.getAttribute('data-section-id');
    var my = ++seq;
    var updates = {};
    updates[oldId] = 0;
    updates[newId] = qty;
    setLoading(root, true);
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: id, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (my !== seq) return;
        var html = state.sections && state.sections[id];
        if (html) swap(root, html); else window.location.reload();
        updateHeader(realCount(state), state);
      })
      .catch(function () { window.location.reload(); });
  }

  function saveNote(value) {
    fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: value })
    });
  }

  /* --- delegated events --- */
  document.addEventListener('click', function (e) {
    /* the drawer is in the DOM on /cart too and owns its own [data-step]/[data-remove];
       ignore anything inside it so a drawer tap isn't handled twice. */
    if (e.target.closest('[data-cart-drawer]')) return;
    var pickBtn = e.target.closest('[data-pick-btn]');
    if (pickBtn) { pickFreebie(rootFor(pickBtn), pickBtn); return; }

    var step = e.target.closest('[data-step]');
    if (step) {
      var item = step.closest('[data-cart-item]');
      var input = item.querySelector('[data-qty-input]');
      var prev = parseInt(input.value, 10) || 0;
      var d = parseInt(step.getAttribute('data-step'), 10);
      var stepRoot = rootFor(step);
      var stepKey = item.getAttribute('data-key');
      /* 1 is the floor — a − from there means "remove", so ask first instead of
         silently dropping to 0. Resolve the line by key when the shopper confirms
         (the cart may have re-rendered while the dialog was open). */
      if (d < 0 && prev <= 1) {
        confirmRemove(function () {
          var el = stepRoot.querySelector('[data-cart-item][data-key="' + stepKey + '"]');
          if (el) changeLine(stepRoot, parseInt(el.getAttribute('data-line'), 10), 0);
        });
        return;
      }
      var lineMax = maxFor(item);
      var next = prev + d;
      var capped = false;
      if (next > lineMax) { next = lineMax; capped = true; }
      if (next < 1) next = 1;
      if (next === prev) { if (capped) qtyToast(capMsg(item)); return; }
      input.value = next;
      capState(item);
      try { optimistic(rootFor(step), item, prev, next); } catch (err) { /* preview only — never block the save */ }
      scheduleChange(rootFor(step), item.getAttribute('data-key'), next);
      if (capped) qtyToast(capMsg(item));
      return;
    }
    /* gift-wrap summary rows aren't [data-cart-item] — they carry the line no. */
    var removeLine = e.target.closest('[data-remove-line]');
    if (removeLine) {
      e.preventDefault();
      changeLine(rootFor(removeLine), parseInt(removeLine.getAttribute('data-remove-line'), 10), 0);
      return;
    }

    var remove = e.target.closest('[data-remove]');
    if (remove) {
      e.preventDefault();
      var ri = remove.closest('[data-cart-item]');
      changeLine(rootFor(remove), parseInt(ri.getAttribute('data-line'), 10), 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.closest('[data-cart-drawer]')) return; /* drawer owns its own change handler */
    var box = e.target.closest('[data-wrap-box]');
    if (box) { pickBox(rootFor(box), box); return; }
    var acc = e.target.closest('[data-wrap-acc]');
    if (acc) { pickAcc(rootFor(acc), acc); return; }
    var card = e.target.closest('[data-wrap-card]');
    if (card) { pickCard(rootFor(card), card); return; }

    var vsel = e.target.closest('[data-variant-select]');
    if (vsel) {
      changeVariant(rootFor(vsel), vsel.getAttribute('data-old'), vsel.value, parseInt(vsel.getAttribute('data-qty'), 10) || 1);
      return;
    }

    var input = e.target.closest('[data-qty-input]');
    if (!input) return;
    var item = input.closest('[data-cart-item]');
    var line = parseInt(item.getAttribute('data-line'), 10);
    var lineMax = maxFor(item);
    var qty = parseInt(input.value, 10) || 0;
    /* typing 0 (or blank) is a remove request → confirm, don't drop silently */
    if (qty <= 0) { input.value = 1; capState(item); confirmRemove(function () { changeLine(rootFor(input), line, 0); }); return; }
    var capped = qty > lineMax;
    if (capped) qty = lineMax;
    input.value = qty;
    capState(item);
    changeLine(rootFor(input), line, qty);
    if (capped) qtyToast(capMsg(item));
  });

  document.addEventListener('input', function (e) {
    if (e.target.closest('[data-cart-drawer]')) return; /* drawer owns its own input handler */
    var msg = e.target.closest('[data-wrap-msg]');
    if (msg) {
      var block = msg.closest('[data-wrap]');
      clearTimeout(msgTimer);
      msgTimer = setTimeout(function () { saveMessage(block); }, 600);
      return;
    }

    var note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote(note.value); }, 600);
  });

  /* Promo code: Shopify has no cart-level "apply discount" endpoint, so we
     navigate to /discount/<CODE> which sets the discount cookie and redirects
     back to the cart. It's a plain div (not a <form>) because the page is
     already one big cart form and the browser strips nested forms. */
  function applyPromo(wrap) {
    var input = wrap.querySelector('[data-promo-input]');
    var code = (input && input.value || '').trim();
    if (!code) { if (input) input.focus(); return; }
    var rootUrl = wrap.getAttribute('data-root') || '/';
    var cartUrl = wrap.getAttribute('data-cart-url') || '/cart';
    window.location.href = rootUrl + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(cartUrl);
  }
  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-promo-apply]');
    if (!apply) return;
    var wrap = apply.closest('[data-promo-form]');
    if (wrap) applyPromo(wrap);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var input = e.target.closest('[data-promo-input]');
    if (!input) return;
    e.preventDefault();
    var wrap = input.closest('[data-promo-form]');
    if (wrap) applyPromo(wrap);
  });

  /* Public hook so ysl-gwp.js can re-render the page after it adds/removes a
     gift line. No-op off the cart page. */
  function refresh() {
    var root = document.querySelector('.ysl-cart' + ROOT_SEL);
    if (!root) return Promise.resolve();
    var id = root.getAttribute('data-section-id');
    var my = ++seq;
    setLoading(root, true);
    /* NOT `/cart?sections=`. On the cart URL, a request that sends
       `Accept: application/json` is answered with the CART's own JSON
       (token/note/items/...) and the `sections` param is ignored — so data[id]
       came back undefined and the swap silently never happened, leaving the
       page stale while the drawer and the header badge moved on. A no-op
       update.js returns rendered sections reliably and is never full-page
       cached; the drawer already uses this door for the same reason. */
    return fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: {}, sections: id, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (my !== seq) return;
        var data = state && state.sections;
        /* patch in place when the shape is unchanged (a background cross-sync is
           usually just numbers) so we don't collapse open <details> / lose scroll;
           full swap only when a line came or went. */
        var next = data && data[id] ? (patch(root, data[id]) ? root : swap(root, data[id])) : null;
        /* count rides on the rendered root (data-cart-count) — no extra cart.js.
           mirror silently so this render doesn't re-fire cart:updated → gwp. */
        var count = next && parseInt(next.getAttribute('data-cart-count'), 10);
        if (count || count === 0) mirrorHeader(count);
      })
      .catch(function () { setLoading(root, false); });
  }

  /* The drawer is a SEPARATE section — a mutation on one surface only re-renders
     that surface. When a change originates in the drawer, re-render this page in
     the background so the two never drift. Silent (refresh() mirrors the header
     without re-dispatching → no gwp re-run), debounced, and invisible: on /cart
     the drawer overlays this page, so its refresh lands before it's uncovered. */
  var xRefreshTimer = null;
  function scheduleCartRefresh() {
    if (!document.querySelector('.ysl-cart' + ROOT_SEL)) return;
    if (qtyPending) return; /* mid-edit here — the pending flush will resync */
    clearTimeout(xRefreshTimer);
    xRefreshTimer = setTimeout(function () { if (!qtyPending) refresh(); }, 200);
  }
  document.addEventListener('cart:updated', function (e) {
    if (e.detail && e.detail.rendered) return; /* the mutation already rendered us */
    if (e.detail && e.detail.source === 'drawer') scheduleCartRefresh();
  });

  /* Initial paint of the per-line stepper bounds (grey the + on a line already
     at its stock cap). Renders after this call keep it current via capAll(). */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { capAll(); enforceCaps(); });
  } else {
    capAll(); enforceCaps();
  }

  window.YSLCart = { refresh: refresh, applySection: applySection, isBusy: function () { return !!qtyPending; } };
})();
